__turbopack_context__.v({
  "actions": "WhatIsDealbid-module__CVtlqq__actions",
  "band": "WhatIsDealbid-module__CVtlqq__band",
  "kicker": "WhatIsDealbid-module__CVtlqq__kicker",
  "lede": "WhatIsDealbid-module__CVtlqq__lede",
  "panel": "WhatIsDealbid-module__CVtlqq__panel",
  "stat": "WhatIsDealbid-module__CVtlqq__stat",
  "statFigure": "WhatIsDealbid-module__CVtlqq__statFigure",
  "statLabel": "WhatIsDealbid-module__CVtlqq__statLabel",
  "stats": "WhatIsDealbid-module__CVtlqq__stats",
  "title": "WhatIsDealbid-module__CVtlqq__title",
});
